import React from 'react';
import './Styles.css';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import PrimaryButton from '../../../../Elements/ids/Buttons/PrimaryButton';
import { useNavigate } from 'react-router-dom';

const EmployerSearchResults = ({ results, query }) => {
  const navigate = useNavigate();

  return (
    <div className="searchPage-employerResults-container">
      {results.length === 0 ? (
        <>
          <div className="searchPage-employerResults-title">{formatMessage(Messages.searchPage_employerNoResults)}</div>
          <div className="searchPage-employerResults-createButton">
            <PrimaryButton
              text={formatMessage(Messages.searchPage_createEmployerButton)}
              onClickEvent={() => {
                navigate('/employer/add', { state: { name: query } });
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="common-table-row searchPage-employerResults-row headerRow">
            <div></div>
            <div>{formatMessage(Messages.common_name)}</div>
            <div>{formatMessage(Messages.common_country)}</div>
            <div>{formatMessage(Messages.common_mobile)}</div>
            <div>{formatMessage(Messages.common_phone)}</div>
            <div>{formatMessage(Messages.common_email)}</div>
          </div>
          {results.map((employer, index) => (
            <div
              key={employer.id ?? 0}
              className={`common-table-row searchPage-employerResults-row clickable ${
                index % 2 === 1 ? 'common-table-evenRow' : ''
              }`}
              onClick={() => {
                navigate(`/employer/view/${employer.id}`);
              }}>
              <div>
                <img aria-hidden className="if size-24" src="/assets/worker24.svg" alt="Employer" />
              </div>
              <div>{employer.name}</div>
              <div>{employer.country?.name}</div>
              <div>{employer.mobile}</div>
              <div>{employer.phone}</div>
              <div>{employer.email}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default EmployerSearchResults;
